import { Provider } from 'react-redux';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import { FullPageLoader } from '@web/utils';
import { UserAuthGuard } from '@/components/UserAuthGuard';
import FarmersLayout from '@/layouts/farmers/FarmersLayout';
import SimpleLayout from '@/layouts/simple/SimpleLayout';
import App from '@/pages/App';
import { AppStoreRedirect } from '@/pages/AppStoreRedirect';
import { DeepLinkPage } from '@/pages/FarmerPages/DeepLinkPage';
import {
  ContractDetailsPage,
  ContractsPage,
  DocumentsLayout,
  InvoiceDetailsPage,
  InvoicesPage,
  OrderDetailsPage,
  OrdersPage,
} from '@/pages/FarmerPages/DocumentsPages';
import {
  CheckoutPage,
  RetailerHomePage,
  RetailerLayout,
  RetailerPage,
} from '@/pages/FarmerPages/FarmerRetailerPages';
// import { FarmersHomePage } from '@/pages/FarmerPages/FarmersHomePage';
import { MyFarmPage } from '@/pages/FarmerPages/MyFarmPage';
import { OrderSuccessPage } from '@/pages/FarmerPages/OrderSuccessPage';
import { Page404 } from '@/pages/Page404';
import { LoginPage, ProfilePage } from '@/pages/UserPages';
import store from '../store/store';

const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  {
    path: '/a',
    element: <AppStoreRedirect />,
    handle: { title: 'page_titles.app_store_redirect' },
  },
  {
    element: (
      <Provider store={store}>
        <App />
      </Provider>
    ),
    children: [
      {
        element: <SimpleLayout />,
        children: [
          {
            path: '404',
            element: <Page404 />,
            handle: { title: 'page_titles.page_not_found' },
          },
          { path: '*', element: <Navigate to="/404" /> },
        ],
      },
      {
        path: '/redirect',
        element: <Navigate to="/" replace />,
      },
      {
        path: '/login',
        element: <LoginPage />,
        handle: { title: 'page_titles.login' },
      },
      {
        element: (
          <UserAuthGuard>
            <FarmersLayout />
          </UserAuthGuard>
        ),
        children: [
          {
            path: '/',
            element: <FullPageLoader />,
            handle: { title: 'page_titles.home' },
          },
          { path: 'd', element: <DeepLinkPage /> },
          { path: 'o', element: <DeepLinkPage /> },
          {
            element: <RetailerLayout />,
            path: ':retailerId',
            children: [
              {
                index: true,
                element: <RetailerPage />,
                handle: { title: 'page_titles.retailer' },
              },
              {
                path: 'profile',
                element: <ProfilePage />,
                handle: { title: 'page_titles.profile' },
              },
              {
                path: 'info',
                element: <RetailerHomePage />,
                handle: { title: 'page_titles.retailer_info' },
              },
              {
                path: 'checkout',
                element: <CheckoutPage />,
                handle: { title: 'page_titles.checkout' },
              },
              {
                path: 'documents',
                element: <DocumentsLayout />,
                children: [
                  {
                    path: 'farm',
                    element: <MyFarmPage />,
                    handle: { title: 'page_titles.farm' },
                  },
                  {
                    path: 'order/:orderId/success',
                    element: <OrderSuccessPage />,
                    handle: { title: 'page_titles.order_success' },
                  },
                  {
                    path: 'orders',
                    element: <OrdersPage />,
                    handle: { title: 'page_titles.orders' },
                  },
                  {
                    path: 'orders/:orderId',
                    element: <OrderDetailsPage />,
                    handle: { title: 'page_titles.order_details' },
                  },
                  // { path: 'documents', element: <DocumentsPage /> },
                  {
                    path: 'invoices',
                    element: <InvoicesPage />,
                    handle: { title: 'page_titles.invoices' },
                  },
                  {
                    path: 'invoices/:invoiceId',
                    element: <InvoiceDetailsPage />,
                    handle: { title: 'page_titles.invoice_details' },
                  },
                  {
                    path: 'contracts',
                    element: <ContractsPage />,
                    handle: { title: 'page_titles.contracts' },
                  },
                  {
                    path: 'contracts/:contractId',
                    element: <ContractDetailsPage />,
                    handle: { title: 'page_titles.contract_details' },
                  },
                ],
              },
            ],
          },

          {
            path: ':retailerId/*',
            element: <Navigate to="/404" replace />,
          },
        ],
      },
      {
        path: '*',
        element: <Navigate to="/404" replace />,
      },
    ],
  },
]);

export default router;
